import { z } from 'zod';

/**
 * Görevler: the team's to-do list. A task is for one person, written by themselves
 * or given by a colleague (tasks.assign), may be due on a day and may point at a
 * sale. Request schemas here; shapes in contract.ts.
 */

const id = z.uuid();
const version = z.number().int().positive();
const blankToNull = <T>(v: T) => (v === '' ? null : v);
const optional = (max: number) =>
  z.string().trim().max(max).nullable().optional().transform(blankToNull);
const day = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Tarihi seçin')
  .nullable()
  .optional()
  .or(z.literal('').transform(() => null));

export const TASK_PRIORITIES = ['normal', 'high'] as const;
export type TaskPriority = (typeof TASK_PRIORITIES)[number];

const title = z.string().trim().min(1, 'Görevi yazın').max(200, 'En fazla 200 karakter');

export const createTaskInput = z.object({
  title,
  notes: optional(4000),
  /** Who does it; the writer, when left out. */
  assigneeUserId: id.nullable().optional(),
  dueDate: day,
  priority: z.enum(TASK_PRIORITIES).default('normal'),
  saleId: id.nullable().optional(),
});
export type CreateTaskInput = z.input<typeof createTaskInput>;

export const updateTaskInput = z
  .object({
    title,
    notes: optional(4000),
    assigneeUserId: id,
    dueDate: day,
    priority: z.enum(TASK_PRIORITIES),
    saleId: id.nullable(),
  })
  .partial()
  .extend({ version });
export type UpdateTaskInput = z.input<typeof updateTaskInput>;

export const taskListQuery = z.object({
  /** Mine: given to me. Given: I gave to others. All: everything I reach. */
  view: z.enum(['mine', 'given', 'all']).default('mine'),
  status: z.enum(['open', 'done']).default('open'),
  q: z.string().trim().max(100).optional(),
  saleId: id.optional(),
  limit: z.coerce.number().int().min(1).max(500).default(300),
});
